/**
 * Whether a collaboration load failed because the proposal is gone or is no longer this viewer's to
 * see, as opposed to failing transiently.
 *
 * The distinction decides whether a page may eject the viewer. Both proposal editors treated ANY load
 * error as "still resolving" and so kept waiting: a reviewer opening a deleted draft sat on a loading
 * indicator forever instead of being told and sent back. Redirecting on every error would be worse —
 * a blip would throw people out of a proposal they still have open — so only a settled, terminal
 * answer counts.
 *
 * This lives apart from `use-persisted-proposal-collaboration` deliberately. It is pure, and the
 * editors' specs mock that hook module wholesale; importing the predicate from there would make it
 * `undefined` under test and leave every page spec re-declaring a copy of this rule.
 */
export function isProposalNoLongerAvailableError(error: unknown): boolean {
  if (typeof error !== "object" || error === null) return false;
  const status = (error as { status?: unknown }).status;
  // 404 gone, 410 deleted, 403 no longer permitted — each is a final answer about this proposal.
  return status === 404 || status === 410 || status === 403;
}
